module.exports = __webpack_public_path__ + "static/img/prod_pic08.68225e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod_pic08.jpg
// module id = O744
// module chunks = 5